import { Brand } from "../api/types";

export const DEFAULT_BRAND: Brand = {
  id: "default-brand",
  name: "O2 Business",
  logoUrl: "https://prod-hub-public-asset-a8fc0c53.s3.eu-west-2.amazonaws.com/o2/img/O2B_vert_blue_rgb_no_border.svg",
  faviconUrl: "https://prod-hub-public-asset-a8fc0c53.s3.eu-west-2.amazonaws.com/o2/img/favicon.ico",
  widgetArea1: "",
  widgetArea2: "",
  backgroundImageUrl: "https://prod-hub-public-asset-a8fc0c53.s3.eu-west-2.amazonaws.com/o2/img/brand_bg.jpg",

  primaryColour: "#0050ff",
  primaryTextColour: "#ffffff",
  secondaryColour: "#00008c",
  secondaryTextColour: "#ffffff",
  tertiaryColour: "#ffffff",
  tertiaryTextColour: "#000000",

  hubUrl: "",
  headingText: "O2 Business My Account",
  subHeadingText: "Built to make every business better",
  globalBrandRef: "",
  welcomeText: "",
  welcomeEmailFrom: "",
  footerLinks: [],
};
